module.exports = __webpack_public_path__ + "static/media/icon-out-of-gamut.4eef9021.svg";